import { render, staticRenderFns } from "./LabelEdit.vue?vue&type=template&id=ab41f3f8&scoped=true&"
import script from "./LabelEdit.vue?vue&type=script&lang=js&"
export * from "./LabelEdit.vue?vue&type=script&lang=js&"
import style0 from "./LabelEdit.vue?vue&type=style&index=0&id=ab41f3f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab41f3f8",
  null
  
)

export default component.exports